import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {  UpdateStudentDiscount } from "../../api/StudentServices";
import BusStudentview from "../buses/Bus_studentview";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import {
  closeModal,
  formatDate,
  ToastMain,
  SweetAlertShow,
} from "../master/Master";
import {
  BusRoute,
  BusStudent,
  BusStudentCreate,
  BusView,
  GetBus,
} from "../../api/BusService";
import { viewlist } from "../../api/BatchService";
import { student } from "../../api/StudentServices";
import { studentDetails } from "../../api/Student";
export default function CourseFeeInfo() {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState("");
  const [studentView, setStudentView] = useState();
  const [profileImage, setProfileImage] = useState();
  const [modalData, setModalData] = useState("");
  const location = useLocation();
  const [routes, setRoutes] = useState([]);
  const [buses, setBuses] = useState([]);
  const [searchBusId, setsearchBusId] = useState("");
  const [selectedRouteId, setSelectedRouteId] = useState("");
  const [busFees, setBusFees] = useState("");
  const [busFinalFees, setBusFinalFees] = useState("");
  const [busDiscount, setBusDiscount] = useState("");
  const [SelectedBusId, setSelectedBusId] = useState("");
  const [batchId, setBatchId] = useState(null);
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [selectedStudentId, setSelectedStudentId] = useState("");
  const [studentlist, setStudentlist] = useState([]);
  const [batches, setBatches] = useState([]);
  // const [busDiscount, setBusDiscount] = useState("");

  // const studentId = location.state?.id;

  const queryParams = new URLSearchParams(location.search);
  const studentId = queryParams.get("id");

  const navigate = useNavigate();
  useEffect(() => {
    if (busFees && busFinalFees) {
      const discount = busFees - busFinalFees;
      setBusDiscount(discount);
    }
  }, [busFees, busFinalFees]);
  const fetchStudentsByBatch = async () => {
    let addUrl = `&batch_id=${batchId}`;
    try {
      const response = await student(addUrl);
      const allStudents = response?.data?.data?.data || [];
      setStudentlist(allStudents);
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.messag ??
          error?.response?.message ??
          error?.message
      );
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
    }
  };

  useEffect(() => {
    if (batchId) {
      fetchStudentsByBatch();
    }
  }, [batchId]);

  const getBatchList = async () => {
    try {
      const response = await viewlist();
      setBatches(response.data?.batches || []);
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );

    }
  };
  useEffect(() => {
    getBatchList();
  }, []);

  // Normally this data will come from API or parsed PDF
  useEffect(() => {
    if (studentId) {
      getStudent(studentId);
    }
  }, [studentId]);

  const getStudent = async (id) => {
    setLoading(true);
    try {
      const response = await studentDetails(`id=${id}`);
      if (response.data) {
        setStudentView(response.data);
        setProfileImage(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
    } finally {
      setLoading(false);
    }
  };

  const updateDicount = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await UpdateStudentDiscount(formData);

      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
        // ToastMain.fire({
        //   icon: "success",
        //   title: "Create Successfully!",
        // });

        // form clear karo
        e.target.reset();

        closeModal("Courseedit");
        getStudent(studentId);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
        // ToastMain.fire({
        //   icon: "info",
        //   title: "Something Went Wrong!",
        // });
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Went Wrong!",
      // });
    } finally {
      setLoading(false);
    }
  };

  const Addstudent = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData(e.target);

      const response = await BusStudentCreate(formData); // 👈 send JSON

      if (response.status === true) {
        await ToastMain.fire({
          icon: "success",
          title: "Student Successfully Added",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          closeModal("addinbus");
          getStudent();
        });
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.messag ??
          error?.message
      );
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Went Wrong!",
      // });
    }
  };

  const handleBusChange = async (busId) => {
    setsearchBusId(busId);
    setRoutes([]);
    setSelectedRouteId("");
    setBusFees("");
    setBusFinalFees("");
    setBusDiscount("");

    try {
      const res = await BusRoute(busId);
      let routeList = res?.data?.data?.data || res?.data?.data || [];

      if (!Array.isArray(routeList)) {
        routeList = [routeList];
      }

      setRoutes(routeList);

      if (routeList.length > 0) {
        setSelectedRouteId(routeList[0].id.toString());
        setBusFees(routeList[0].route_fee || "");
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
    }
  };

  const handleRouteChange = (routeId) => {
    setSelectedRouteId(routeId);
    const selected = routes.find(
      (route) => route.id.toString() === routeId.toString()
    );
    setBusFees(selected?.route_fee || "");
  };

  const busList = async () => {
    let addUrl = `&bus_id=${SelectedBusId}&student_id=${studentId}&batch_id=${batchId}`;
    setLoading(true);
    try {
      const response = await GetBus(addUrl);
      if (response.data) {
        setBuses(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something Want Wrong!",
        // });
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Want Wrong!",
      // });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    busList();
  }, []);
  useEffect(() => {
    busList();
  }, [SelectedBusId, studentId, batchId]);

  const Info = ({ label, value, isBadge = false }) => (
    <p className="mb-2">
      <strong>{label}:</strong>{" "}
      {value ? (
        isBadge ? (
          <span className="badge text-light">{value}</span>
        ) : (
          <span className="text-muted">{value}</span>
        )
      ) : (
        <span className="text-muted">-</span>
      )}
    </p>
  );

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper container-fluid  flex-grow-1 ">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="card mb-4 p-5">
                  <div className="d-flex gap-3 justify-content-end"></div>

                  <div className="d-flex flex-wrap gap-3 ">
                    <Link
                      to={`/student/details?id=${studentId}`}
                      className="btn btn-sm btn-label-primary"
                    >
                      Student Profile
                    </Link>

                    <Link
                      to={`/student/course_fee?id=${studentId}`}
                      className="btn btn-sm btn-primary"
                    >
                      Course & Fee
                    </Link>
                    <Link
                      to={`/student/hostel?id=${studentId}`}
                      className="btn btn-sm btn-label-primary"
                    >
                      Student Hostel
                    </Link>
                    <Link
                      to={`/student/marks_report?id=${studentId}`}
                      className="btn btn-sm btn-label-primary"
                    >
                      Marks Report
                    </Link>
                    <Link
                      to={`/student/kit_report?id=${studentId}`}
                      className="btn btn-sm btn-label-primary"
                    >
                      Kit Report
                    </Link>
                    <Link
                      to={`/students`}
                      className="btn btn-sm btn-outline-primary ms-auto"
                    >
                      <i className="bi bi-arrow-left-circle me-1"></i> Back
                    </Link>
                  </div>
                </div>
                {/* Student Info Card */}

                {/* Course & Fees Info */}
                <div className="card border-0 shadow rounded-4 p-4 mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="text-primary fw-semibold m-0">
                      Course & Fee Info
                    </h4>

                    {/* <button
                      className="btn btn-primary"
                      onClick={() => navigate("/student/batch/enroll")}
                    >
                      Add New Batch
                    </button> */}
                  </div>

                  <div className="table-responsive">
                    <table className="table table-hover align-middle text-center">
                      <thead className="table-primary">
                        <tr>
                          <th>Session</th>
                          <th>Course & Batch</th>
                          <th>Total Course Fees</th>
                          <th>Course Discount</th>
                          <th>Course Fees</th>
                          <th>Total Paid</th>
                          <th>Pending Amount</th>
                          <th>Registration Fees</th>
                          <th>Bus Fees</th>
                          <th>Total Fees</th>

                          {/* <th>Actions</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {studentView?.student?.course_and_fees?.map(
                          (fee, index) => (
                            <tr key={index}>
                              <td>{fee?.session_year?.session || "-"}</td>
                              <td>
                                {fee?.course?.title}&nbsp;
                                <span className="text-primary fw-bold">
                                  ({fee?.batch?.title})
                                </span>
                                {fee?.batch?.status === "0" && (
                                  <span
                                    className="badge rounded bg-label-warning ms-2"
                                    disabled
                                  >
                                    Upcoming
                                  </span>
                                )}
                                {fee?.batch?.status === "1" && (
                                  <span
                                    className="badge rounded bg-label-success ms-2"
                                    disabled
                                  >
                                    Running
                                  </span>
                                )}
                                {fee?.batch?.status === "2" && (
                                  <span
                                    className="badge rounded bg-label-danger ms-2"
                                    disabled
                                  >
                                    Completed
                                  </span>
                                )}
                              </td>

                              <td>₹{fee?.batch_fees}</td>
                              <td className="text-success fw-bold">
                                ₹{fee?.batch_discount || 0}
                              </td>
                              <td className="text-success fw-bold">
                                ₹{fee?.total_fee}
                              </td>
                              <td className="text-success fw-bold">
                                ₹{fee?.fees_paid || 0}
                                <button
                                  className="btn text-info ms-2"
                                  data-bs-toggle="modal"
                                  data-bs-target="#Courseedit"
                                  onClick={() => setModalData(fee)}
                                >
                                  <i className="bi bi-pencil-square"></i>
                                </button>
                              </td>
                              <td className="text-danger fw-bold">
                                ₹{fee?.left_amount || 0}
                              </td>
                              <td className="text-secondary fw-bold">
                                ₹{fee?.reg_fee || 0}
                              </td>
                              <td className="text-warning fw-bold">
                                ₹{fee?.bus_final_fees || 0}
                              </td>
                              <td className="text-secondary fw-bold">
                                ₹
                                {(Number(fee?.total_fee) || 0) +
                                  (Number(fee?.bus_final_fees) || 0)}
                              </td>

                              <td>
                                {/* Action Buttons */}
                                {/* {fee?.fees_paid == 0 &&(
                                  <>
                                  <Link to={`/batch_transfer?student=${studentView?.student?.id}`} className="btn btn-sm btn-primary">
                                 &#x21C6;
                                </Link></>
                                )} */}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Fee Transactions Table */}
                <div className="card border-0 shadow rounded-4 p-4 mb-5">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="text-primary fw-semibold">BUS Details:</h4>
                    <div>
                      <button
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#addinbus"
                      >
                        Admit in Bus
                      </button>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-hover align-middle">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Bus Number</th>
                          <th>Bus Route</th>
                          <th>Total Bus Fee</th>
                          <th>Bus Fee</th>
                          <th>Bus Discount</th>
                          <th>Status</th>
                          <th>Bus Add Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {studentView?.student?.course_and_fees?.map(
                          (item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item?.bus?.bus_number}</td>
                              <td>{item?.route?.route_name}</td>
                              <td>{item?.bus_fees}</td>
                              <td className="text-success fw-bold">
                                ₹{item?.bus_final_fees || 0}
                              </td>

                              <td className="text-success fw-bold">
                                ₹{item?.bus_discount}
                              </td>
                              <td>
                                <button className="btn text-info">
                                  {item?.status === "1" ? "Active" : "Inactive"}
                                </button>
                              </td>
                              <td>{formatDate(item?.admission_date)}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Emi Transactions Table */}
                {studentView?.student?.emi?.length > 0 && (
                  <div className="card border-0 shadow rounded-4 p-4 mb-5">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className="text-primary fw-semibold">Emi Details:</h4>
                      <div></div>
                    </div>

                    <div className="table-responsive">
                      <table className="table table-hover align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Emi Date</th>
                            <th>Emi Amount</th>
                            <th>Paid Amount</th>
                            <th>Emi Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {studentView?.student?.emi?.map((emiItem, index) => {
                            const relatedCourse =
                              studentView?.student?.course_and_fees?.find(
                                (c) => c.id === emiItem.course_n_fee_id
                              );

                            return (
                              <tr key={emiItem.id}>
                                <td>{index + 1}</td>
                                <td>{formatDate(emiItem.emi_date)}</td>
                                <td>₹{emiItem.emi_amount}</td>
                                <td>₹{emiItem?.paid_amount}</td>
                                <td>
                                  <span
                                    className={`badge ${
                                      emiItem.emi_payment_status === "Complete"
                                        ? "bg-success"
                                        : "bg-danger"
                                    }`}
                                  >
                                    {emiItem.emi_payment_status}
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Fee Transactions Table */}
                <div className="card border-0 shadow rounded-4 p-4 mb-5">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="text-primary fw-semibold">
                      Fee Transactions:
                    </h4>
                    <div>
                      <button className="btn btn-info text-white me-2">
                        Active Transections
                      </button>
                      <button
                        className="btn btn-danger text-white me-2"
                        onClick={() => alert("Delete sccesfuley")}
                      >
                        Deleted Transection
                      </button>
                    </div>
                  </div>
                  <div className=" mb-4 text-start">
                    <strong className="mx-2">Total : 17600</strong>
                    <strong className="mx-2">Total Paid : 17600</strong>
                    <strong className="mx-2">Total Panding : 0 </strong>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-hover align-middle">
                      <thead className="table-light">
                        <tr>
                          <th>Sr.no</th>
                          <th>Fee Trans Id</th>
                          <th>Fee Type</th>

                          <th>Amount</th>
                          <th>Date</th>
                          {/* <th>Remark</th> */}
                          <th>Payment Method</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {studentView?.student?.transaction?.map(
                          (item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item?.transaction_no ?? item?.id}</td>
                              <td>{item?.fee_type || "N/A"}</td>

                              <td>
                                <button className="btn text-success fw-bold">
                                  ₹{item?.amount}
                                </button>
                              </td>
                              <td>{formatDate(item.fee_date)}</td>

                              <td>{item?.payment_method}</td>
                              <td>
                                <Link
                                  to={`/student/fees/receipt?id=${item.id}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-sm btn-outline-primary"
                                >
                                  <i className="bi bi-printer"></i>
                                </Link>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* modal1 */}

      <div
        className="modal fade"
        id="Courseedit"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={updateDicount}>
              {/* Modal Header */}
              <div className="modal-header bg-label-primary py-3">
                <h1 className="modal-title fs-5">
                  Course Fees Discount Change
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>

              {/* Modal Body */}
              <div className="modal-body">
                {/* Disclaimer Section */}
                <div className="alert alert-info mb-4" role="alert">
                  <strong>Important:</strong> Changing the course fee will
                  affect the student's billing and records. Please ensure the
                  information provided is accurate and authorized.
                </div>

                <input
                  type="hidden"
                  name="course_and_fees_id"
                  value={modalData?.id}
                />

                {/* Fee Info Section */}
                <div className="mb-3 d-flex ">
                  <span className="fw-semibold">Total Course Fee (₹):</span>
                  <span className="text-primary">
                    {modalData?.batch_fees || "-"}
                  </span>
                </div>

                <div className="mb-3 d-flex ">
                  <span className="fw-semibold">Final Fee (₹):</span>
                  <span className="text-primary">
                    {modalData?.total_fee || "-"}
                  </span>
                </div>

                <div className="mb-4 d-flex ">
                  <span className="fw-semibold">Before Fee Discount (₹):</span>
                  <span className="text-primary">
                    {modalData?.batch_discount || "-"}
                  </span>
                </div>

                {/* Fee Discount Input */}
                <div className="mb-4 form-floating form-floating-outline">
                  <input
                    type="text"
                    name="fees_discount"
                    className="form-control"
                    required
                    defaultValue={modalData?.total_fee || ""}
                  />
                  <label>Fee Discount (₹)</label>
                </div>

                {/* Remark */}
                <div className="mb-4 form-floating form-floating-outline">
                  <textarea
                    name="discount_remark"
                    className="form-control input-uppercase"
                    required
                  />
                  <label>Remark</label>
                </div>

                {/* Upload Proof */}
                <div className="mb-4 form-floating form-floating-outline">
                  <input
                    type="file"
                    name="discount_img"
                    className="form-control"
                  />
                  <label>Upload Change Proof</label>
                </div>
              </div>

              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade modal-xl"
        id="first2"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Deposit Fee ( NUR. )
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="container p-4 rounded-4">
                {/* Fee Summary Table */}
                <div className="mb-4">
                  <table className="table text-center align-middle m-0">
                    <tbody>
                      <tr>
                        <th className="w-50 border-0">Registration Fee</th>
                        <td className="border-0">₱ 0</td>
                      </tr>
                      <tr>
                        <th className="border-0">Bus Fee</th>
                        <td className="border-0">₱</td>
                      </tr>
                      <tr>
                        <th className="border-0">Course Fee</th>
                        <td className="border-0">₱ 12000</td>
                      </tr>
                      <tr>
                        <th className="border-0">Total Fee</th>
                        <td className="border-0">₱ 12000</td>
                      </tr>
                      <tr
                        className="text-white fw-bold"
                        style={{
                          background:
                            "linear-gradient(90deg, #1abc9c,rgb(73, 152, 148)#16a085)",
                        }}
                      >
                        <th className="border-0">Fees Paid</th>
                        <td className="border-0">₱ 8000</td>
                      </tr>
                      <tr
                        className="text-white fw-bold"
                        style={{
                          background:
                            "linear-gradient(90deg, #e74c3c, #c0392b)",
                        }}
                      >
                        <th className="border-0 text-white">Left Amount</th>
                        <td className="border-0 text-white">₱ 4000</td>
                      </tr>
                      <tr>
                        <th className="border-0">Total EMI</th>
                        <td className="border-0">-</td>
                      </tr>
                      <tr>
                        <th className="border-0">EMI Amount</th>
                        <td className="border-0">-</td>
                      </tr>
                      <tr>
                        <th className="border-0">Next EMI Date</th>
                        <td className="border-0">2025-04-22</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Fee Payment Form */}
                <div>
                  <div className="mb-4 d-flex gap-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="feeType"
                        id="registrationFee"
                        value={"registration"}
                        defaultChecked
                      />
                      <label className="form-check-label">
                        Registration Fee
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="feeType"
                        id="feesDeposit"
                        value={"deposit"}
                      />
                      <label className="form-check-label">Fees Deposit</label>
                    </div>
                  </div>

                  <form>
                    <div className="row g-4">
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          Select Type
                        </label>
                        <select className="form-select rounded">
                          <option>Fee EMI Payment</option>
                          <option>Full Payment</option>
                          <option>Advance Payment</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          Enter Amount
                        </label>
                        <input
                          type="number"
                          className="form-control rounded"
                          value={4000}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          Payment Method
                        </label>
                        <input
                          type="text"
                          className="form-control rounded"
                          placeholder="Payment Method"
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          Transaction ID
                        </label>
                        <input
                          type="text"
                          className="form-control rounded"
                          placeholder="Transaction ID"
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">Remark</label>
                        <input
                          type="text"
                          className="form-control rounded input-uppercase"
                          placeholder="Remark"
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          Fee Date
                        </label>
                        <input
                          type="date"
                          className="form-control rounded"
                          value={"2025-05-29"}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-semibold">
                          Next Payment Date (Optional)
                        </label>
                        <input type="date" className="form-control rounded" />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="modal-footer border-0">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade "
        id="first3"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Transfer Student To Other Batch
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="input-group input-group-xl mb-3">
                {/* <h4>Student :</h4> */}
                <label className="fs-3"> Student :</label>
                <select
                  className="form-select form-control"
                  aria-label="Default select example"
                  name="new_batch_id"
                  required=""
                >
                  <option selected="">Select Batch</option>
                  <option value="44">10 (X)</option>
                  <option value="45">REMOVE BATCH (REMOVE STUDENTS)</option>
                  <option value="46">a (VII)</option>
                  <option value="47">b (VII)</option>
                  <option value="48">A (VI)</option>
                  <option value="50">B (VI)</option>
                  <option value="51">III (III)</option>
                  <option value="54">A (IV)</option>
                  <option value="55">B (IV)</option>
                  <option value="56">3 test office (III)</option>
                  <option value="57">II (II)</option>
                  <option value="58">a (I)</option>
                  <option value="59">b (I)</option>
                  <option value="60">A (UKG.)</option>
                  <option value="61">B (UKG.)</option>
                  <option value="62">NUR. (NUR.)</option>
                  <option value="63">A (LKG.)</option>
                  <option value="64">B. (LKG.)</option>
                  <option value="65">TEST MARK (TEST MAR)</option>
                  <option value="66">a (NUR.)</option>
                  <option value="67">Test (I)</option>
                </select>
                {/* <button
                  className="btn btn-outline-secondary btn-sm text-start dropdown-toggle w-50"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Select
                </button>
                <ul className="dropdown-menu dropdown-menu-end w-100">
                  <li>
                    <a className="dropdown-item" href="#">
                      Action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Another action
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Something else here
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Separated link
                    </a>
                  </li>
                </ul> */}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Admit in Bus model */}
      <div
        className="modal fade"
        id="addinbus"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={Addstudent}>
              <div className="modal-header bg-label-primary text-white p-3">
                <h5 className="modal-title">Add Student</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                />
              </div>

              <div className="modal-body">
                <div className="row">
                  <input
                    type="hidden"
                    name="batch_id"
                    value={studentView?.student?.course_and_fees?.[0].batch?.id}
                  />
                  <input type="hidden" name="student_id" value={studentId} />

                  {/* Bus */}
                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <select
                      name="bus_id"
                      className="form-control"
                      value={searchBusId}
                      onChange={(e) => handleBusChange(e.target.value)}
                    >
                      <option value="">Select Bus</option>
                      {buses.map((bus) => (
                        <option key={bus.id} value={bus.id}>
                          {bus.bus_number}
                        </option>
                      ))}
                    </select>
                    <label>Select Bus</label>
                  </div>

                  {/* Route */}
                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <select
                      name="route_id"
                      className="form-control"
                      value={selectedRouteId}
                      onChange={(e) => handleRouteChange(e.target.value)}
                    >
                      <option value="">Select Route</option>
                      {Array.isArray(routes) && routes.length > 0 ? (
                        routes.map((route) => (
                          <option key={route.id} value={route.id}>
                            {route.route_name}
                          </option>
                        ))
                      ) : (
                        <option disabled>No routes found</option>
                      )}
                    </select>
                    <label>Select Route</label>
                  </div>

                  {/* Bus Fees */}
                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      name="bus_fees"
                      className="form-control"
                      value={busFees}
                      readOnly
                    />
                    <label>Bus Fees</label>
                  </div>

                  {/* Final Fees */}
                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <input
                      type="number"
                      name="bus_final_fees"
                      className="form-control"
                      value={busFinalFees}
                      onChange={(e) => setBusFinalFees(e.target.value)}
                    />
                    <label>Final Fees</label>
                  </div>

                  {/* Discount */}
                  <div className="mb-3 col-md-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      name="bus_discount"
                      className="form-control"
                      value={busDiscount}
                      readOnly
                    />
                    <label>Discount</label>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save Student Detail
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="updata"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="container my-5">
                <h2 className="text-center mb-4">Update Student Details</h2>
                <form>
                  <h5>Student Details</h5>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label>Session</label>
                      <input
                        type="text"
                        className="form-control"
                        value="2024-2025"
                        disabled
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Registration No*</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="56756"
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Student Name*</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="anvi choudhary"
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Mobile No*</label>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="9166709462"
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Father's Name*</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="saitan rewar"
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Mother's Name*</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="abhisake"
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Gender*</label>
                      <select className="form-control">
                        <option>Female</option>
                        <option>Male</option>
                        <option>Other</option>
                      </select>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Alternative mobile no*</label>
                      <input type="tel" className="form-control" />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Email</label>
                      <input type="email" className="form-control" />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Category</label>
                      <select className="form-control">
                        <option>Select Category</option>
                      </select>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Aadhar No</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Date of Birth</label>
                      <input type="date" className="form-control" />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>NIC ID</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Apaar ID</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Roll Number</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>

                  <h5 className="mt-4">Address Details</h5>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label>Village</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Chomu"
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Tehsil</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>State</label>
                      <select className="form-control">
                        <option>Select State</option>
                      </select>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>District</label>
                      <select className="form-control">
                        <option>Select District</option>
                      </select>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Pincode</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>

                  <h5 className="mt-4">Student Image</h5>
                  <div className="mb-3">
                    <input type="file" className="form-control" />
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Admit Hostel  */}
      <div
        className="modal fade"
        id="AdmitHostel"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Admit Student in Hostel
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label for="hostel" className="form-label">
                    Select Hostel
                  </label>
                  <input
                    type="text"
                    className="form-control input-uppercase"
                    id="hostel"
                    name="hostel"
                    placeholder="Enter hostel name"
                  />
                </div>

                <div className="mb-3">
                  <label for="monthlyFee" className="form-label">
                    Enter Monthly Fee
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="monthlyFee"
                    name="monthlyFee"
                    placeholder="Enter fee amount"
                  />
                </div>

                <div className="mb-3">
                  <label for="joiningDate" className="form-label">
                    Hostel Joining Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="joiningDate"
                    name="joiningDate"
                  />
                </div>
              </form>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="UploadDocoument"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-ml">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Upload Student Document
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mx-auto my-4 p-4" style={{ maxWidth: 600 }}>
                <form>
                  <div className="mb-3">
                    <label htmlFor="aadhar" className="form-label fw-semibold">
                      Aadhar
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="aadhar"
                      name="aadhar"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="tenth" className="form-label fw-semibold">
                      10th
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="tenth"
                      name="tenth"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="twelfth" className="form-label fw-semibold">
                      12th
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="twelfth"
                      name="twelfth"
                    />
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="signature"
                      className="form-label fw-semibold"
                    >
                      Signature
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="signature"
                      name="signature"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="photo" className="form-label fw-semibold">
                      Photo
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="photo"
                      name="photo"
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="other" className="form-label fw-semibold">
                      Other
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="other"
                      name="other"
                    />
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
